export default "__VITE_ASSET__BMZ6exY$__"